<template>
    <div class="toast" role="alert" aria-live="assertive" aria-atomic="true" :class="toastClass">
      <div class="toast-header">
        <strong class="mr-auto">Correo enviado</strong>
        <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" @click="closeToast">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="toast-body">
        El correo se ha enviado correctamente.
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        show: true,
      };
    },
    computed: {
      toastClass() {
        return {
          'toast-show': this.show,
        };
      },
    },
    methods: {
      closeToast() {
        this.show = false;
      },
      showToast() {
        this.show = true;
      },
    },
  };
  </script>
  
  <style scoped>
  .toast-show {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 1050;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/layout/Toast.vue